import React from 'react';
import { Gift } from 'lucide-react';

// Round photo cropped into a circle; falls back to a gift icon when no image is set.
const Bubble = ({ image, accent, className = '' }) => (
  <div
    className={`rounded-full overflow-hidden bg-white shadow-xl shrink-0 ${className}`}
    style={{ border: `4px solid ${accent}` }}
    data-testid="gift-promo-bubble"
  >
    {image ? (
      <img src={image} alt="Free gift" className="w-full h-full object-cover" loading="lazy" />
    ) : (
      <div className="w-full h-full flex items-center justify-center text-shrimp-orange">
        <Gift className="w-1/2 h-1/2" />
      </div>
    )}
  </div>
);

const Pill = ({ gift, accent, ink, className = '' }) => (
  <div
    className={`rounded-full px-3 py-1 text-center shadow-lg whitespace-nowrap ${className}`}
    style={{ backgroundColor: accent, color: ink }}
    data-testid="gift-promo-pill"
  >
    <p className="text-[11px] sm:text-xs font-extrabold leading-tight tracking-wide" data-testid="gift-promo-title">{gift.title}</p>
    <p className="text-[9px] sm:text-[10px] font-semibold leading-tight opacity-80" data-testid="gift-promo-subtitle">{gift.subtitle}</p>
  </div>
);

// Design A "sticker": pinned over the banner's top-right corner on sm+ screens,
// shown as a centred row under the text on phones. Colours follow the banner.
export const GiftPromoSticker = ({ gift, accent = '#ffffff', ink = '#000000' }) => {
  if (!gift) return null;
  return (
    <>
      <div
        className="hidden sm:flex absolute -top-7 -right-5 flex-col items-center pointer-events-none"
        data-testid="gift-promo-sticker"
      >
        <Bubble image={gift.image} accent={accent} className="w-28 h-28 rotate-6" />
        <Pill gift={gift} accent={accent} ink={ink} className="-mt-3 -rotate-3" />
      </div>
      <div className="sm:hidden mt-3 flex items-center justify-center gap-3" data-testid="gift-promo-sticker-mobile">
        <Bubble image={gift.image} accent={accent} className="w-16 h-16" />
        <Pill gift={gift} accent={accent} ink={ink} />
      </div>
    </>
  );
};

// Standalone strip used when no sale banner is active.
export const GiftPromoStrip = ({ gift, className = '' }) => {
  if (!gift) return null;
  return (
    <div
      className={`rounded-xl p-4 mb-6 shadow-lg bg-shrimp-green text-white flex items-center gap-4 ${className}`}
      data-testid="gift-promo-strip"
    >
      <Bubble image={gift.image} accent="#ffffff" className="w-16 h-16 sm:w-20 sm:h-20" />
      <div className="min-w-0">
        <p className="font-display text-lg sm:text-xl font-bold leading-snug" data-testid="gift-promo-strip-text">{gift.stripText}</p>
        <p className="text-xs opacity-90 mt-1">Basket items of €{gift.threshold.toFixed(2)} or more — we add it to your parcel automatically.</p>
      </div>
    </div>
  );
};
